
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30732',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30732",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55250",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8291",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11746",
  "I18n": "static-7.1665",
  "quartz": "static-1.7399",
  "quartz-config": "static-1.1177",
  "quartz-core": "static-1.6618",
  "react-dlb": "static-1.87",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.880",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55237",
  "feedback-utils": "static-1.55241",
  "forms-embed-utils-lib": "static-1.4728",
  "forms-utils-lib": "static-1.13041",
  "foundations-assets": "static-1.5146",
  "foundations-components": "static-1.8422",
  "foundations-theming": "static-1.4730",
  "hub-http": "static-1.6476",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12053",
  "icons": "static-2.675",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4106",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16974",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5529",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.497",
  "tinymce-plugins": "static-1.58147",
  "transmute": "static-2.85",
  "ui-images": "static-2.1234",
  "UIComponents": "static-3.8692",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3676",
  "quartz-webpack": "static-1.3623",
  "foundations-theming-specialty": "static-1.2446",
  "property-description-translator": "static-1.4103",
  "HeadJS": "static-2.791",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3402",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4578",
  "jasmine-runner": "static-1.6715",
  "opentelemetry-fe-types": "static-1.32",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4838",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.407",
  "quartz-auth": "static-1.1074",
  "quartz-head": "static-1.1064",
  "quartz-i18n": "static-1.1074",
  "quartz-routing": "static-1.829",
  "quartz-test": "static-1.1074",
  "quartz-tracking": "static-1.778",
  "trellis-components": "static-1.2546",
  "ui-fonts": "static-1.1008",
  "usage-tracker-container": "static-1.7609",
  "usage-tracker-core": "static-1.7469",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7512",
  "reference-resolvers": "static-1.8442",
  "sanitize-text": "static-1.8414",
  "PatternValidationJS": "static-1.3159",
  "ReduxMessenger": "static-2.10631",
  "outpost": "static-1.4422",
  "rpc-client-utils": "static-1.4925",
  "sanitize": "static-1.4738",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4691",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9689",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.64",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2527",
  "bend-plugin-foundations-theming": "static-1.3213",
  "foundations-theming-base": "static-1.3715",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.268",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9631",
  "atom": "static-1.5348",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8151",
  "ContentUtils": "static-1.69063",
  "data-token-picker": "static-1.16836",
  "file-manager-components": "static-1.24400",
  "FileManagerCore": "static-1.39899",
  "FileManagerLib": "static-1.40040",
  "frontend-preferences-client": "static-1.8188",
  "hub-http-contrib": "static-1.3300",
  "interframe": "static-3.5018",
  "layout-dnd-components": "static-1.12910",
  "layout-dnd-utils": "static-1.11885",
  "property-translator": "static-1.5660",
  "react-codemirror": "static-1.10901",
  "react-colorpicker": "static-2.10470",
  "reference-resolvers-lite": "static-1.8363",
  "rich-text-lib": "static-1.20254",
  "tinymce-data": "static-1.41118",
  "tinymce-themes": "static-1.57003",
  "ui-addon-emoji-picker": "static-1.10148",
  "ui-addon-sales-email": "static-1.5477",
  "ui-brand-identity-lib": "static-1.16312",
  "bender-build-tools": "static-1.3401",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10553",
  "hubspotter-http-shared-msw-handlers": "static-1.10551",
  "usage-tracker-session-replay": "static-1.5305",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1229",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.335",
  "chirp-fetch": "static-1.2156",
  "chatspot-core": "static-1.22734",
  "copilot-toolkit": "static-1.11777",
  "customer-data-objects-ui-components": "static-1.13291",
  "data-fetching-client": "static-1.9920",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5019",
  "ui-addon-video-player": "static-1.8965",
  "ui-coaching-tips": "static-1.29244",
  "usage-tracker": "static-1.7619",
  "cms-field-types": "static-1.5077",
  "content-icons-ui": "static-1.2326",
  "integrations-lib": "static-1.16961",
  "customer-data-objects": "static-1.7949",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1614",
  "apollo-link-hub-http": "static-2.4918",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4413",
  "ui-addon-iframeable": "static-1.9336",
  "video-components-external": "static-1.12088",
  "video-data-lib": "static-1.35746",
  "breeze-artifacts-sdk": "static-1.228",
  "audio-components": "static-1.6291",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29755",
  "FileManagerImages": "static-1.37551",
  "foundations-components-legacy": "static-1.1447",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.532",
  "ui-universal-auth": "static-1.9323",
  "urlinator": "static-1.4795",
  "video-components": "static-1.14090",
  "video-embed": "static-1.36580",
  "ts-schema": "static-1.4269",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10210",
  "react-dnd-compat": "static-1.4878",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1804",
  "external-options-client-types": "static-1.4315",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7155",
  "hs-promise-utils": "static-1.5857",
  "inbound-db-properties-service-client": "static-1.4032",
  "NamespacedHubStyle": "static-2.9237",
  "growth-onboarding-confetti": "static-1.3325",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11406",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5728",
  "magpie-types": "static-1.5188",
  "simple-logging-lib": "static-1.3313",
  "avatar-components": "static-1.2757",
  "customer-data-ui-utilities": "static-1.10090",
  "growth-onboarding-feedback-components": "static-1.6846",
  "flux-actions": "static-1.362",
  "hubspot-apollo-client": "static-1.5141",
  "integrations-error-boundary-lib": "static-1.14376",
  "integrations-tracking-lib": "static-1.5870",
  "laboratory-lib": "static-3.7414",
  "native-integrations-shared-strings": "static-1.8040",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10528",
  "unified-auth": "static-1.837",
  "breeze-engine-chat-components": "static-1.592",
  "breeze-engine-core": "static-1.892",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8069",
  "content-media-composition-data-lib": "static-1.13158",
  "content-media-compositions": "static-2.17165",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19355",
  "unified-auth-core-lib": "static-1.1119",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15527",
  "advanced-menus-lib": "static-1.12406",
  "ExportDialog": "static-6.10641",
  "ui-memberships-settings-lib": "static-1.34773",
  "conditional-properties-service-client": "static-1.3987",
  "crm-pipelines-api-client-types": "static-1.4323",
  "fdsr-migration-layer": "static-1.274",
  "framework-builder-read-service-client": "static-1.4197",
  "framework-data-schema-quick-fetch": "static-1.7060",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3884",
  "persist-promise": "static-1.3961",
  "foundations-components-test-utils": "static-1.5905",
  "reactive-lib": "static-1.983",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.600",
  "universal-page-editor-lib": "static-1.3270",
  "adobe-sign-auth-lib": "static-1.385",
  "ads-unified-auth-lib": "static-1.1161",
  "google-sheets-integration-lib": "static-1.960",
  "microsoft-drive-auth-lib": "static-1.57",
  "surveymonkey-integration-lib": "static-1.403",
  "slack-ui-library": "static-1.10661",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4004",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15526",
  "simple-menus-lib": "static-1.17043",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10022",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30732",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55250",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8291",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11746",
  "I18n": "/I18n/static-7.1665",
  "quartz": "/quartz/static-1.7399",
  "quartz-config": "/quartz-config/static-1.1177",
  "quartz-core": "/quartz-core/static-1.6618",
  "react-dlb": "/react-dlb/static-1.87",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.880",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55237",
  "feedback-utils": "/feedback-utils/static-1.55241",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4728",
  "forms-utils-lib": "/forms-utils-lib/static-1.13041",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "foundations-components": "/foundations-components/static-1.8422",
  "foundations-theming": "/foundations-theming/static-1.4730",
  "hub-http": "/hub-http/static-1.6476",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12053",
  "icons": "/icons/static-2.675",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4106",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16974",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5529",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "tinymce-plugins": "/tinymce-plugins/static-1.58147",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1234",
  "UIComponents": "/UIComponents/static-3.8692",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3676",
  "quartz-webpack": "/quartz-webpack/static-1.3623",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2446",
  "property-description-translator": "/property-description-translator/static-1.4103",
  "HeadJS": "/HeadJS/static-2.791",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3402",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4578",
  "jasmine-runner": "/jasmine-runner/static-1.6715",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.32",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.407",
  "quartz-auth": "/quartz-auth/static-1.1074",
  "quartz-head": "/quartz-head/static-1.1064",
  "quartz-i18n": "/quartz-i18n/static-1.1074",
  "quartz-routing": "/quartz-routing/static-1.829",
  "quartz-test": "/quartz-test/static-1.1074",
  "quartz-tracking": "/quartz-tracking/static-1.778",
  "trellis-components": "/trellis-components/static-1.2546",
  "ui-fonts": "/ui-fonts/static-1.1008",
  "usage-tracker-container": "/usage-tracker-container/static-1.7609",
  "usage-tracker-core": "/usage-tracker-core/static-1.7469",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "reference-resolvers": "/reference-resolvers/static-1.8442",
  "sanitize-text": "/sanitize-text/static-1.8414",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "ReduxMessenger": "/ReduxMessenger/static-2.10631",
  "outpost": "/outpost/static-1.4422",
  "rpc-client-utils": "/rpc-client-utils/static-1.4925",
  "sanitize": "/sanitize/static-1.4738",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4691",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9689",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2527",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3213",
  "foundations-theming-base": "/foundations-theming-base/static-1.3715",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.268",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9631",
  "atom": "/atom/static-1.5348",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8151",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "data-token-picker": "/data-token-picker/static-1.16836",
  "file-manager-components": "/file-manager-components/static-1.24400",
  "FileManagerCore": "/FileManagerCore/static-1.39899",
  "FileManagerLib": "/FileManagerLib/static-1.40040",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8188",
  "hub-http-contrib": "/hub-http-contrib/static-1.3300",
  "interframe": "/interframe/static-3.5018",
  "layout-dnd-components": "/layout-dnd-components/static-1.12910",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11885",
  "property-translator": "/property-translator/static-1.5660",
  "react-codemirror": "/react-codemirror/static-1.10901",
  "react-colorpicker": "/react-colorpicker/static-2.10470",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8363",
  "rich-text-lib": "/rich-text-lib/static-1.20254",
  "tinymce-data": "/tinymce-data/static-1.41118",
  "tinymce-themes": "/tinymce-themes/static-1.57003",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10148",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5477",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16312",
  "bender-build-tools": "/bender-build-tools/static-1.3401",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10553",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10551",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5305",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1229",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.335",
  "chirp-fetch": "/chirp-fetch/static-1.2156",
  "chatspot-core": "/chatspot-core/static-1.22734",
  "copilot-toolkit": "/copilot-toolkit/static-1.11777",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13291",
  "data-fetching-client": "/data-fetching-client/static-1.9920",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5019",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8965",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29244",
  "usage-tracker": "/usage-tracker/static-1.7619",
  "cms-field-types": "/cms-field-types/static-1.5077",
  "content-icons-ui": "/content-icons-ui/static-1.2326",
  "integrations-lib": "/integrations-lib/static-1.16961",
  "customer-data-objects": "/customer-data-objects/static-1.7949",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1614",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4918",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4413",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9336",
  "video-components-external": "/video-components-external/static-1.12088",
  "video-data-lib": "/video-data-lib/static-1.35746",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.228",
  "audio-components": "/audio-components/static-1.6291",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29755",
  "FileManagerImages": "/FileManagerImages/static-1.37551",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1447",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.532",
  "ui-universal-auth": "/ui-universal-auth/static-1.9323",
  "urlinator": "/urlinator/static-1.4795",
  "video-components": "/video-components/static-1.14090",
  "video-embed": "/video-embed/static-1.36580",
  "ts-schema": "/ts-schema/static-1.4269",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10210",
  "react-dnd-compat": "/react-dnd-compat/static-1.4878",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1804",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7155",
  "hs-promise-utils": "/hs-promise-utils/static-1.5857",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9237",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3325",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11406",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5728",
  "magpie-types": "/magpie-types/static-1.5188",
  "simple-logging-lib": "/simple-logging-lib/static-1.3313",
  "avatar-components": "/avatar-components/static-1.2757",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10090",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6846",
  "flux-actions": "/flux-actions/static-1.362",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5141",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14376",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5870",
  "laboratory-lib": "/laboratory-lib/static-3.7414",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8040",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10528",
  "unified-auth": "/unified-auth/static-1.837",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.592",
  "breeze-engine-core": "/breeze-engine-core/static-1.892",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8069",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13158",
  "content-media-compositions": "/content-media-compositions/static-2.17165",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19355",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1119",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15527",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12406",
  "ExportDialog": "/ExportDialog/static-6.10641",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34773",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3987",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4323",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.274",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4197",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7060",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3884",
  "persist-promise": "/persist-promise/static-1.3961",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5905",
  "reactive-lib": "/reactive-lib/static-1.983",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.600",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3270",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.385",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1161",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.960",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.57",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.403",
  "slack-ui-library": "/slack-ui-library/static-1.10661",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4004",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15526",
  "simple-menus-lib": "/simple-menus-lib/static-1.17043",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10022",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
